import axios from 'axios';

export const fileUpload = async (url, file, config) => {
    let rsp = null;
    let isError = false;

    try {
        const axiosResult = await axios.post(url, file, config);

        if (axiosResult.data !== null){
            const { code, message, metadata } = axiosResult.data;
            isError = ( code === '00' ? false : true );
            rsp = {
                code: code,
                message: message,
                metadata: metadata,
                loading: false,
                isError: isError,
                httpCode: 200
            };
        }
        else{
            rsp = {
                code: null,
                message: "Success",
                metadata: null,
                loading: false, 
                isError: isError,
                httpCode: 200
            }
        }
    } catch (error) {
        rsp = {
            // code: null,
            // message: error.message,
            // metadata: null,
            // loading: false, 
            // isError: false,
            // httpCode: 200
            code: null,
            message: error.message,
            metadata: null,
            loading: false, 
            isError: true,
            httpCode: `${error.response?.status}`
        }
    }
    
    return rsp;
}
